// fetch('/cart.js').then((resp) => resp.json()).then((data) => console.log(data.items))

// UTILS
function addToCartDatalayer(product) {
  let quantity = product.dataset.jsWrapper ? product.dataset.quantity :  Number(product.value) - Number(product.dataset.quantity) 

  let obj = {
    event: "add_to_cart_GA4",
    ecommerce: {
      items: [
        {
          item_name: product.dataset.name,
          item_id: product.dataset.jsWrapper ? product.dataset.wrapper : product.dataset.productId,
          price: Number(product.dataset.price),
          item_category: product.dataset.category,
          item_brand: product.dataset.brand,
          quantity: Number(quantity),
          add_to_cart_location: "Cart",
          add_to_cart_type: "Quick buy",
          image_url: product.dataset.image,
          handle: product.dataset.handle,
          categories: product.dataset.categories
        }
      ]
    }
  }
  if (window.dataLayer != void 0) {
    window.dataLayer.push(obj);
  }
}


function getProperties(element) {
  if (!element.dataset?.jsProperties) return null
   // Transformer les properties en tableau d'objets
   return JSON.parse(element.dataset.jsProperties).reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
}
function updateParentProperty (element, sectionsSet, line, quantity, price, wrapperValue) {
  // Transformer les properties en tableau d'objets
  const propertiesFormatted = getProperties(element)

  return {
    sections: sectionsSet,
    sections_url: window.location.pathname,
    line: Number(line),
    quantity: quantity,
    properties: { 
      ...propertiesFormatted, 
      _wrapper: wrapperValue,
      _wrapperPrice: Number(price)
    },
  };
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerItems = document.getElementById('CartDrawer-CartItems');
    this.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    event.preventDefault();
    this.isConfigurator = this.dataset.jsConfigurator;
    this.hasWrapper = this.dataset.wrapper?.length > 0 && this.dataset.wrapper !== 'false';
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    
    if (this.isConfigurator) {
      await this.handleConfigurator();
    } else {
      await this.cartItems.updateQuantity(this, this.dataset.index, 0, '');
    }

  }
  async handleConfigurator() {
    // les ids qui sont dans le package du configurator
    const idsConfig = this.dataset.jsIdConfig.split('|');
    
    for (const [index, id] of idsConfig.entries()) {
      let rerender = index === idsConfig.length - 1;

      const itemParent = this.closest('.configurator-item');
      const item = itemParent.querySelector(`.cart-drawer-items[data-id='${id}']`);
      
      if (item) {
        await this.updateItem(item, rerender);
      }
    }
  }

  async updateItem(item, rerender) {
    const line = item.dataset.index;
    const body = {
      line: line,
      quantity: 0,
      sections: [...new Set(this.cartItems.getSectionsToRender().map(section => section.section))],
      sections_url: window.location.pathname
    };

    await this.cartItems.updateCartAndRerender(routes.cart_change_url, JSON.stringify(body), rerender);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartGift extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerItems = document.getElementById('CartDrawer-CartItems');
    this.addGiftButton = this.querySelector('[data-js-add-gift]');
    this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    this.addGiftButton.addEventListener('click', this.handleAddGift.bind(this));
  }
  async handleAddGift() {
   // Supprimer les cadeaux existants s'il y en a
   let existingGifts = document.querySelectorAll('[data-is-gift]');
   if (existingGifts.length > 0) {
     await this.removeExistingGifts(existingGifts);
   }
   // Ajouter un nouveau cadeau
   this.addGiftToCart()
  }
  async removeExistingGifts(existingGifts) {
    // Create a promise array to wait for all gift removals to complete
    const updatePromises = [...existingGifts].map((gift) => {
      return this.cartItems.updateQuantity(gift, gift.dataset.index, 0, '', false);
    });
    // Wait for all the promises to resolve
    await Promise.all(updatePromises);
  }
  addGiftToCart() {
    const body = {
      items: [
        {
          id: this.addGiftButton.dataset.productId,
          quantity: 1,
          properties: { '_gift': true }
        }
      ],
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    this.cartItems.updateCartAndRerender(routes.cart_add_url, JSON.stringify(body));
  }
}

customElements.define('cart-gift', CartGift);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawerItems = document.getElementById('CartDrawer-CartItems')
    this.wrappers = [...this.cart.querySelectorAll('[data-js-wrapper]')];

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.currentItemCount = this.getCurrentItemCount()

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // wrappers
    if (this.wrappers) {
      this.wrappers.forEach(input => {
        input.addEventListener('change', (event) => {
          this.giftWrapperManager(event)
        });
      })
    }
  }

  async onChange(event) {
    let isQuantitySafe = this.checkQuantityIfDiscount(event)
    if (!isQuantitySafe) return

    if (!event.target.id.includes('wrapper')) {
    
      await this.updateQuantity(event.target, event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      // si la quantité augmente, envoie add to cart au datalayer
      if (Number(event.target.value) > Number(event.target.dataset.quantity)) {
        addToCartDatalayer(event.target)
      }

    }
  }

  getCurrentItemCount() {
    return Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
  }
  checkQuantityIfDiscount(event) {
    let quantity = event.target.dataset.quantity
    let isDiscount = event.target.dataset.isDiscount
    let isTwin = event.target.dataset.isTwin

    let twin = null
    if (isDiscount) {
      twin = document.querySelector(`.cart-drawer-items[data-id='${event.target.dataset.id}'][data-is-twin='true']`)
    } else if (isTwin) {
      twin = document.querySelector(`.cart-drawer-items[data-id='${event.target.dataset.id}'][data-is-discount='true']`)
    } else {
      return true
    }

    if (twin) {
      // s'il y a un jumeau on vérifier que la quantité d'excède pas 10
      if (Number(twin.dataset.quantity) + Number(event.target.value) > 10) {
        // on remet le selecteur comme il était
        document.querySelector('[data-js-quantity-error]').classList.remove('u-hidden')
        event.target.value = quantity
        return false
      } else {
        return true
      }
    } else {
      return true
    }

  }
  async giftWrapperManager(event) {
    let line = event.target.dataset.index
    let giftWrapperId = event.target.dataset.wrapper // l' emballage
    let price = event.target.dataset.price
    let sectionsSet = [...new Set(this.getSectionsToRender().map((section) => section.section))]
    
    // si l'event target est checked
    if (event.target.checked) {
      let quantity = Number(event.target.dataset.quantity)

      // update property du produit emballé
      let updateParentProps = updateParentProperty(event.target, sectionsSet, line, quantity, price, giftWrapperId)
      await this.updateCartAndRerender(routes.cart_change_url, JSON.stringify(updateParentProps))

      addToCartDatalayer(event.target)
    } else {

      // on enlève la property du produit parent
      let quantity = Number(event.target.dataset.quantity)
      let updateParentProps = updateParentProperty(event.target, sectionsSet, line, quantity, price, false)

      await this.updateCartAndRerender(routes.cart_change_url, JSON.stringify(updateParentProps))

    }
  }

  updateCartAndRerender(cartRoute, body, rerender = true) {
    this.enableLoading()

    return fetch(cartRoute, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
     .then((state) => {
      if (!rerender) return
      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach(((section) => {
        // get element to replace
        const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        // set new html
        if(elementToReplace) {
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      }));
    })
    .finally(async () => {
      if (!rerender) return
      await this.checkFreeGift()
      this.disableLoading();
      this.reviveNecessaryFunctions()

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  getSectionsToRender() {
    return [ 
      {
        id: 'header',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble'
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
				id: 'cart-panel',
				section: 'cart-drawer',
				selector: '#freeGift',
			},
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
      
    ];
  }

  updateQuantity(element, line, quantity, name = '', rerender = true, byId = false) {
   // If cart emptied, empty cart message, counts the products and remove them from count if is gift so we trigger when the last product visible is deleted
   let allProducts = this.querySelectorAll('.cart-drawer-items')
    let totalProducts = allProducts.length

    allProducts.forEach((product) => {
      if(product.classList.contains('u-hidden')) {
        totalProducts --;
      }
    })

    this.enableLoading(line);
      
    let sectionsSet = [...new Set(this.getSectionsToRender().map((section) => section.section))]

    // si on veut supprimer par id et non par line
    let bodyData = {
      quantity: quantity,
      sections: sectionsSet,
      sections_url: window.location.pathname,
    };

    let propertiesArray = getProperties(element)
    if (propertiesArray) {
      bodyData.properties = { 
        ...propertiesArray, 
        _add_to_cart_location: 'cart' 
      }
    }
    if (byId) {
      bodyData.id = line;
    } else {
      bodyData.line = Number(line);
    }
  

    let body = JSON.stringify(bodyData);

    return fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        if (!rerender) return
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
  
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach(((section, index) => {
          // get element to replace
          const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          
          // set new html
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        
      })
      .finally(async () => {
        if (!rerender) return
        // est-ce que le montant est en dessous du cadeau offert ?
        await this.checkFreeGift()
        this.disableLoading();
        this.reviveNecessaryFunctions()
        if(quantity == 0 && totalProducts <= 1) {
          document.dispatchEvent(new CustomEvent('personalizedMessage:empty'))
        }


      })
      .catch(() => {
        this.disableLoading();
      });

  }
  checkFreeGift() {
    return new Promise((resolve) => {
      let freeGiftContent = document.querySelector('#freeGift');
      if (!freeGiftContent.querySelector('[data-is-free-gift]')) {
        // on vérifie qu'il n'y a pas de cadeau, s'il y en a un on l'enlève
        let existingGifts = document.querySelectorAll('[data-is-gift]');
        if (existingGifts.length > 0) {
          // supprimer les gifts existants
          [...existingGifts].forEach(async (gift) => {
             await this.updateQuantity(gift, gift.dataset.id, 0, '', true, true);
             resolve(); // Indique que l'opération est terminée
          });
        } else {
          resolve(); 
        }
      } else {
        resolve(); // Indique que l'opération est terminée
      }
    });
  }
  reviveNecessaryFunctions() {
    // revive les islands prorpres au cart non vide (sidebar, personalized message, product recommendations)
    document.dispatchEvent(new CustomEvent('CART_NO_EMPTY:revive'));

    // si le cart est vide, il faut relancer le slider également ainsi que les couleurs
    if (document.querySelector('cart-drawer-items.is-empty')) {
      document.dispatchEvent(new CustomEvent('clrz-render-section-card-product:revive',  { detail: { container: document.querySelector('cart-drawer.is-empty') }   }))
      document.dispatchEvent(new CustomEvent('clrz-slider-card-product:rerender',  { detail: { container: document.querySelector('cart-drawer.is-empty') }   }));
      document.dispatchEvent(new CustomEvent('slider:revive'));
      document.dispatchEvent(new CustomEvent('revive:stand-by',  { detail: { container: document.querySelector('cart-drawer.is-empty') }   }));
      document.dispatchEvent(new CustomEvent('product:card-rerender',  { detail: { container: document.querySelector('cart-drawer.is-empty') }   }));

      // Je commente cela en attendant de savoir pourquoi cela est nécessaire
      // document.querySelector('cart-drawer').style.height = 'auto'
    }
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  enableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};


class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.setHeaderCartIconAccessibility();

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const product = urlParams.get('cart');

		if (product == 'true') {
			this.open();
      const overlay = document.querySelector('[data-js-overlay-blur]');
		  if (overlay) overlay.classList.add('is-active', '!u-z-60');
		}
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelectorAll('cart__bubble');
		cartLink.forEach((el) => {
			el.setAttribute('role', 'button');
			el.setAttribute('aria-haspopup', 'dialog');
			el.addEventListener('click', (event) => {
				event.preventDefault();
				this.open(el);
			});
			el.addEventListener('keydown', (event) => {
				if (event.code.toUpperCase() === 'SPACE') {
					event.preventDefault();
					this.open(el);
				}
			});
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			// Trigger ClrzSidebar open method
			document.dispatchEvent(new CustomEvent('clrz-sidebar:open'));
		});
	}

	close() {
    document.body.classList.remove('u-overflow-hidden');
		this.classList.remove('is-visible');
		removeTrapFocus(this.activeElement);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute(
				'aria-controls',
				cartDrawerNote.nextElementSibling.id,
			);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute(
				'aria-expanded',
				!event.currentTarget.closest('details').hasAttribute('open'),
			);
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.cartItemKey = parsedState.key;
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {

			const sectionElement = section.selector
			? document.querySelector(section.selector)
			: document.getElementById(section.id);
      
			if (sectionElement && parsedState.sections) {
				sectionElement.innerHTML = this.getSectionInnerHTML(
					parsedState.sections[section.id],
					section.selector,
				);
			}
		});

		const updateCart = new CustomEvent('updateCart');
		document.dispatchEvent(updateCart);
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('CART_NO_EMPTY:revive'));
      this.open();
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
	}

  // Attention MAX 5 sections ici
	getSectionsToRender() {
		return [
			{
				id: 'header',
				section: 'cart-icon-bubble',
				selector: '#cart-icon-bubble',
			},
			{
				id: 'cart-drawer',
        section: 'cart-drawer',
				selector: '#CartDrawer-count',
			},
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer-footer',
      },
      {
				id: 'cart-drawer',
				selector: '#CartDrawer-wrapper',
			}
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  
  // Attention MAX 5 sections ici
	getSectionsToRender() {
		return [
      {
				id: 'header',
				section: 'cart-icon-bubble',
				selector: '#cart-icon-bubble',
			},
      {
				id: 'CartDrawer-count',
        section: 'cart-drawer',
				selector: '#CartDrawer-count',
			},
      {
			id: 'CartDrawer-wrapper',
				section: 'cart-drawer',
				 selector: '#CartDrawer-wrapper',
			},
			{
        id: 'CartDrawer-footer',
				section: 'cart-drawer',
				selector: '#CartDrawer-footer',
			},
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);
